export const DEBOUNCE_DELAY = 500
